import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useTranslation } from '@lib/useTypedTranslation';

import { decode } from '../lib/base64';
import { InvalidPage } from '../components/errors/invalidPage';
import { DeviceAnomaliesPage } from '../containers/core/deviceAnomalies/deviceAnomaliesPage';
import { useWorldRoutes } from './parts/allWorldRoutes';

export const CoreDeviceAnomalyRoute = () => {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const encodedId = searchParams.get('id');
  const deviceId = encodedId ? decode(encodedId) : undefined;
  const routes = useWorldRoutes();
  const { t } = useTranslation('redirect');

  const notFound = (
    <InvalidPage
      message={t('DEVICE_ANOMALY_NOT_FOUND')}
      redirect={{
        message: t('REDIRECT_TO_ANOMALY_DETECTION_BETA'),
        path: routes.core.anomalyDetectionBeta
      }}
    />
  );

  if (!deviceId) {
    return notFound;
  }

  return <DeviceAnomaliesPage deviceId={deviceId} />;
};
